export const REPORT_ACCESS_RIGHTS_REQUEST = 'REPORT_ACCESS_RIGHTS_REQUEST'

export const REPORT_GET_TOKEN_REQUEST = (entityId) => `REPORT_GET_${entityId}_TOKEN_REQUEST`
export const REPORT_ENTITY_UPDATE = (entityId) => `REPORT_ENTITY_${entityId}_UPDATE`
export const REPORT_REMOVE = 'REPORT_REMOVE'

export const OPEN_REPORT_BY_ID = 'OPEN_REPORT_BY_ID'
export const CLOSE_REPORT_BY_ID = 'CLOSE_REPORT_BY_ID'

export const LOAD_REPORT_MODULE_ACCESS_RIGHTS = 'LOAD_REPORT_MODULE_ACCESS_RIGHTS'
export const SET_REPORT_MODULE_ACCESS_RIGHTS = 'SET_REPORT_MODULE_ACCESS_RIGHTS'

export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Report'
export const REPORT_LOADER_ID = 'reportLoader'
